export const aciFilterEqualizer = {
    iconName: 'filter-equalizer',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 20 20' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M5.556 3.334a.74.74 0 00-.741.74v5.927h-.74a.74.74 0 100 1.481h.74v4.445a.74.74 0 001.481 0v-4.445h.741a.74.74 0 100-1.481h-.74V4.075a.74.74 0 00-.741-.741zm4.444 0a.74.74 0 00-.74.74v2.964h-.741a.74.74 0 100 1.481h.74v7.408a.74.74 0 001.482 0V8.519h.74a.74.74 0 100-1.481h-.74V4.075a.74.74 0 00-.74-.741zm3.704.74a.74.74 0 111.481 0v7.408h.741a.74.74 0 010 1.482h-.74v2.963a.74.74 0 11-1.482 0v-2.963h-.74a.74.74 0 110-1.482h.74V4.075z',
                fill: 'currentColor',
            },
        },
    },
};
